//
import * as React from 'react';

import MuiTextField from '@mui/material/TextField';

import { getIn } from 'formik';

export const fieldToTextField = ({ field, form, disabled = false, ...props }) => {
  const { name, value } = field;
  const { touched, errors, isSubmitting } = form;

  const fieldError = getIn(errors, name);
  // note, the form.submitCount is required to fix empty field not being returned in touched when submitting
  const showError = (getIn(touched, name) || form.submitCount > 0) && !!fieldError;

  return {
    ...props,
    ...field,
    error: showError,
    helperText: showError ? fieldError : props.helperText,
    disabled: isSubmitting || disabled,
    value: value || '',
  };
};

const handleBlur = (onBlur, onFieldBlur) => (e) => {
  onBlur(e);

  if (onFieldBlur) {
    onFieldBlur(e, e.target.value);
  }
};

const handleChange = (onChange, onFieldChange) => (e) => {
  onChange?.(e);

  onFieldChange?.(e, e.target.value);
};

const FormikTextField = ({ children, ...props }) => {
  const { onBlur, onChange, onFieldBlur, onFieldChange, ...textFieldProps } = fieldToTextField(props);

  return (
    <MuiTextField
      onBlur={handleBlur(onBlur, onFieldBlur)}
      onChange={handleChange(onChange, onFieldChange)}
      {...textFieldProps}
    >
      {children}
    </MuiTextField>
  );
};

FormikTextField.displayName = 'FormikTextField';

export default FormikTextField;
